/** Base for files in `public/` (Create React App). */
const PUBLIC = process.env.PUBLIC_URL || "";

/** Official TAPSOA logo: `client/public/logo.png`. */
export const TAPSOA_LOGO_PNG = `${PUBLIC}/logo.png`;

/**
 * Absolute URL for the logo (for @react-pdf Image and same-origin fetches).
 * @param {string} [explicit] — if set, returned as-is
 */
export function resolveTapsoaLogoUrlForPdf(explicit) {
  if (explicit) return explicit;
  if (typeof window !== "undefined" && window.location?.origin) {
    return `${window.location.origin}${PUBLIC}/logo.png`;
  }
  return TAPSOA_LOGO_PNG;
}

/** `client/public/signatures/excecutive-secretary.png` (filename spelling as on disk). */
export const EXECUTIVE_SECRETARY_SIGNATURE_PNG = `${PUBLIC}/signatures/excecutive-secretary.png`;

/** Absolute URL for @react-pdf `Image` (same-origin). */
export function resolveExecutiveSecretarySignatureUrlForPdf() {
  if (typeof window !== "undefined" && window.location?.origin) {
    return `${window.location.origin}${PUBLIC}/signatures/excecutive-secretary.png`;
  }
  return EXECUTIVE_SECRETARY_SIGNATURE_PNG;
}

/** `client/public/signatures/chairman-signature.png`. */
export const CHAIRMAN_SIGNATURE_PNG = `${PUBLIC}/signatures/chairman-signature.png`;

/** Absolute URL for @react-pdf `Image` (same-origin). */
export function resolveChairmanSignatureUrlForPdf() {
  if (typeof window !== "undefined" && window.location?.origin) {
    return `${window.location.origin}${PUBLIC}/signatures/chairman-signature.png`;
  }
  return CHAIRMAN_SIGNATURE_PNG;
}
